import { useContext } from "react";
import { Box, Grid, Typography, useMediaQuery } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

import globalStyles from "../../../../../../assets/styles/global.module.scss";
import styles from "../../../../../../assets/styles/componentStyles/organizationTeamsStyles/teams.module.scss";

import GlobalButton from "../../../../../utility/globalButton/button";
import GlobalPopUp from "../../../../../utility/globalPopUp";
import AddEditTeamPopup from "../../utils/AddEditTeamPopup";
import { GlobalTable } from "../../../../../utility/globalTable";
import { organizationTeamsData, organizationUserDataModel } from "../../../../../../models/axiosModel";
import { HeaderListObjectModel } from "../../../../../../models/componentModel";
import { UserContext, UserContextPayload } from "../../../../../../context/userContext";
import { hasOrganizationTeamManageAccess } from "../../../../../../utils/constants";
import { useOrganizationTeamsStore } from "../../../../../../store/organizationTeamsStore";
import { useShallow } from "zustand/react/shallow";

interface TeamMembersProps {
    team: organizationTeamsData;
    organizationUserData: organizationUserDataModel[];
}

const TeamMembers = ({ team, organizationUserData }: TeamMembersProps) => {
    
    const { userDetail, apiRoutesPermissionAssignment } = useContext(UserContext) as UserContextPayload;

    const { editTeamPopup, setEditTeamPopup } = useOrganizationTeamsStore(
        useShallow((state) => ({
            editTeamPopup: state.editTeamPopup,
            setEditTeamPopup: state.setEditTeamPopup,
        }))
    );

    const breakPoints = {
        flagSmallScreen: useMediaQuery<boolean>("(min-width: 0px) and (max-width: 1024px)")
    };

    const tableHeight = hasOrganizationTeamManageAccess(apiRoutesPermissionAssignment, userDetail) ? "42vh" : "52vh";

    const headerList: HeaderListObjectModel[] = [
        {
            name: "First Name",
            alignment: "left",
            flagIcon: false,
            valueKey: "first_name",
            iconKey: "userIcon",
        },
        {
            name: "Last Name",
            alignment: "left",
            flagIcon: false,
            valueKey: "last_name",
            iconKey: "userIcon",
        },
        {
            name: "Email",
            alignment: "left",
            flagIcon: false,
            valueKey: "email",
            iconKey: "emailIcon",
        },
        {
            name: "Added By",
            alignment: "left",
            flagIcon: false,
            valueKey: "added_by_user.private_user_name",
            iconKey: "userIcon",
        },
        {
            name: "Added At",
            alignment: "left",
            flagIcon: false,
            valueKey: "created_at_timestamp",
            iconKey: "timeIcon",
        }
    ];

    return (
        <Box className={`${globalStyles.fullwidth} ${styles.teamDetailsTabContent}`}>
            <Grid container className={`${globalStyles.fullwidth} ${styles.teamDetailsMembersHeader}`}>
                <Typography className={styles.teamDetailsHeaderTitle}>
                    Team Members
                </Typography>

                {hasOrganizationTeamManageAccess(apiRoutesPermissionAssignment, userDetail) && (
                    <GlobalButton
                        buttonText="Edit Team"
                        className="primaryButtonStyle"
                        startIcon={<EditOutlinedIcon />}
                        onClick={() => setEditTeamPopup(true)}
                        sx={{ width: "140px", padding: "5px 15px !important", fontWeight: "500 !important" }}
                    />
                )}
            </Grid>

            <Box className={`${globalStyles.fullwidth} ${styles.teamDetailsMembersTable}`}>
                <GlobalTable
                    headerList={headerList}
                    rowData={team?.organization_team_users}
                    tableHeight={tableHeight}
                    tableContainerHeight="auto"
                    tableContainerMinHeight="auto"
                    onRowClick={() => {}}
                    deleteRowData={() => {}}
                    flagPagination
                />
            </Box>

            {editTeamPopup && (
                <GlobalPopUp
                    open={editTeamPopup}
                    onClose={() => setEditTeamPopup(false)}
                    handleClose={() => setEditTeamPopup(false)}
                    paperMinWidth={breakPoints.flagSmallScreen ? "310px" : "750px"}
                    paperMaxwidth={breakPoints.flagSmallScreen ? "610px" : "750px"}
                    flagShowCloseIcon={true}
                    titlePadding="0px"
                >
                    <AddEditTeamPopup
                        selectedTeam={team}
                        getOrganizationTeamsListApiCall={() => {}}
                        organizationUserData={organizationUserData}
                    />
                </GlobalPopUp>
            )}
        </Box>
    );
};

export default TeamMembers;
